import { formatFileSize } from '../tasks/taskUi';

// The server sends free and total for the disk holding the base folder, and decides the level
export const diskSpaceLine = (status) =>
    status?.diskFreeBytes == null
        ? 'Not available'
        : `${formatFileSize(status.diskFreeBytes) || '0 MB'} free of ${formatFileSize(status.diskTotalBytes)}`;

export const diskNotice = (status) => {
    const free = formatFileSize(status?.diskFreeBytes) || '0 MB';
    if (status?.diskLevel === 'CRITICAL') {
        return {
            severity: 'error',
            text: `Disk space is very low: ${free} free on the server. Start video translation won't run until space is cleared.`,
        };
    }
    if (status?.diskLevel === 'LOW') {
        return {
            severity: 'warning',
            text: `Disk space is low: ${free} free on the server. Large videos may not start.`,
        };
    }
    return null;
};
